import { Component } from '@angular/core';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { NativeCallService } from 'src/app/services/native-call.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'general',
    },
  ],
})
export class FooterComponent {
  constructor(
    private tanslationService: TranslationService,
    public nativeCallService: NativeCallService,
  ) {}
  async ngOnInit() {
    await this.tanslationService.loadScopedTranslation('general');
    console.log(
      'general: ',
      this.tanslationService.loadScopedTranslation('general')
    );
  }
}
